import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/aensa/Farmanimalbanner.jpeg";
import aensaLogo from "assets/images/aensa/new_logo_aensa_transparent.png";
import { useCallback } from "react";
import swal from "sweetalert";
import { ResetPassword } from "rest/requests";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const [user, setUser] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmedPassword, setConfirmedPassword] = useState("");

  const navigate = useNavigate();

  const resetPasswordFunc = useCallback(async () => {
    try {
      await ResetPassword(user, confirmedPassword, newPassword);
      console.log("ok");
      swal("Ok", "Contraseña actualizada exitosamente", "success");
      navigate("/", { replace: true });
    } catch {
      console.log("error");
      swal("Error recuperando contraseña", "Usuario incorrecto o contraseñas incorrectas", "error");
    }
  }, [user, newPassword, confirmedPassword]);

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="dark"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDBox
            key="logo"
            component="img"
            id="logo"
            src={aensaLogo}
            alt={"Aensa Logo "}
            width="30%"
            height="30%"
            bgColor="light"
            borderRadius="lg"
            coloredShadow="dark"
            shadow="lg"
          />
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Bienvenido a EMEVET
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Establecer nueva contraseña
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Correo Electronico"
                variant="standard"
                fullWidth
                InputLabelProps={{ shrink: true }}
                onChange={(event) => setUser(event.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Nueva Contraseña"
                variant="standard"
                fullWidth
                InputLabelProps={{ shrink: true }}
                onChange={(event) => setNewPassword(event.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Confirmar Contraseña"
                variant="standard"
                fullWidth
                InputLabelProps={{ shrink: true }}
                onChange={(event) => setConfirmedPassword(event.target.value)}
              />
            </MDBox>
          </MDBox>

          <MDBox>
            <MDButton
              variant="outlined"
              size="medium"
              color="dark"
              onClick={() => resetPasswordFunc()}
              style={{ margin: "5px" }}
              fullWidth
            >
              Reestablecer
            </MDButton>

            <MDButton
              variant="outlined"
              size="medium"
              color="error"
              fullWidth
              style={{ margin: "5px" }}
              onClick={() => {
                navigate("/", { replace: true });
              }}
            >
              Cancelar
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
      <br></br>
    </CoverLayout>
  );
}

export default ForgotPassword;
